import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showIntro: true,
  showResult: false,
  showTrivia: false,
  showSurvey: false,
  score: 0,
  time: 30,
  currentQuestion: 0,
  currentSurvey: 0,
  currentSurveyQuestion: 0,
  /** Whether the user completed the first survey (before quiz). Used to show survey before Q1. */
  initialSurveyCompleted: false,
  /** 1 = owner path (survey 2 after Q2, survey 3 after Q5); 2 = non-owner (survey 3 only after Q5). */
  surveyPath: null,
  correctAnswers: [],
  selectedAnswers: [],
  chosenProducts: [],
  /** Survey answers by step (1–3). Skipped steps stay ''. */
  chosenAnswer: { 1: '', 2: '', 3: '' },
  userSegment: {},
};

export const gameSlice = createSlice({
  name: 'games',
  initialState,
  reducers: {
    setShowIntro: (state, action) => {
      state.showIntro = action.payload;
    },

    setShowResult: (state, action) => {
      state.showResult = action.payload;
    },

    setShowTrivia: (state, action) => {
      state.showTrivia = action.payload;
    },

    setShowSurvey: (state, action) => {
      state.showSurvey = action.payload;
    },

    setScore: (state, action) => {
      state.score += action.payload;
    },

    setQuestionTime: (state, action) => {
      state.time = action.payload;
    },

    questionTimeReducer: (state) => {
      if (state.time >= 1) {
        state.time -= 1;
      }
    },

    setCurrentQuestion: (state, action) => {
      state.currentQuestion = action.payload;
    },

    setCurrentSurvey: (state, action) => {
      state.currentSurvey = action.payload;
    },

    setCurrentSurveyQuestion: (state, action) => {
      state.currentSurveyQuestion = action.payload;
    },

    setInitialSurveyCompleted: (state, action) => {
      state.initialSurveyCompleted = action.payload;
    },

    setSurveyPath: (state, action) => {
      state.surveyPath = action.payload;
    },

    setCorrectAnswers: (state, action) => {
      state.correctAnswers.push(action.payload);
    },

    setSelectedAnswers: (state, action) => {
      state.selectedAnswers.push(action.payload);
    },

    setChosenProducts: (state, action) => {
      state.chosenProducts.push(...action.payload);
    },

    setChosenAnswer: (state, action) => {
      const { step, answer } = action.payload;
      state.chosenAnswer[step] = answer;
    },

    setUserSegment: (state, action) => {
      state.userSegment = action.payload;
    },

    resetGame: () => initialState,
  },
});

export const {
  setShowIntro,
  setShowResult,
  setShowTrivia,
  setShowSurvey,
  setScore,
  setQuestionTime,
  questionTimeReducer,
  setCurrentQuestion,
  setCurrentSurvey,
  setCurrentSurveyQuestion,
  setInitialSurveyCompleted,
  setSurveyPath,
  setCorrectAnswers,
  setSelectedAnswers,
  setChosenProducts,
  setChosenAnswer,
  setUserSegment,
  resetGame,
} = gameSlice.actions;

export default gameSlice.reducer;
